import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-connecting-animating-icon',
    templateUrl: './connecting-animating-icon.component.html',
    styleUrls: ['./connecting-animating-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ConnectingAnimatingIconComponent {
    constructor() { }
}
